import * as React from "react"

import {User} from "./../model/User"
import {OpkSummaryRow, opkColumns, companyIsOpk} from "./Final"
import {DemandList, DemandByYear, CourseOfStudy, coursesOfStudy, Demand} from "../model/Demand";
import {getCompany, getSpeciality, getUniversityBranch} from "../model/utils/utils";
import {Divisions} from "../model/Division";
import {Speciality, Specialities} from "../model/Speciality";
import {UniversityBranch, UniversityBranches} from "../model/UniversityBranch";
import * as cn from "./Opk.scss"

type Props = {
    demand: DemandList
    divisions: Divisions
    specialities: Specialities
    universityBranches: UniversityBranches
    user: User
    company: string
    total: OpkSummaryRow
    totalOpk: OpkSummaryRow
    totalNotOpk: OpkSummaryRow
    order: number
}

type RowProps = {
    demandByYear: DemandByYear
    speciality: Speciality
    universityBranch: UniversityBranch
    company: {
        company: string
    }
    shift: number
    courseOfStudy: CourseOfStudy
    isOpk: boolean
}

const Row = ({
    demandByYear,
    speciality: {
        title: speciality,
        category,
        code,
    },
    universityBranch: {
        title: university,
    },
    company: {
        company,
    },
    shift,
    courseOfStudy,
    isOpk,
}: RowProps) => (
    <tr className = {cn.row}>
        <td className = {cn.cell}>{university}</td>
        <td className = {cn.cell}>{category}</td>
        <td className = {cn.cell}>{coursesOfStudy[courseOfStudy]}</td>
        <td className = {cn.cell}>{code}</td>
        <td className = {cn.cell}>{speciality}</td>
        <td className = {cn.cell}>{isOpk ? "Да" : "Нет"}</td>
        {opkColumns.map(year => <td {...{key: year}} className = {cn.cell}>{demandByYear[year + shift] || ""}</td>)}
        <td className = {cn.cell}>{opkColumns.reduce((r, year) => r + (demandByYear[year + shift] || 0), 0) || ""}</td>
        <td className = {cn.cell}>{company}</td>
    </tr>
)

export const Opk = ({demand, company, user, divisions, specialities, universityBranches, total, totalOpk, totalNotOpk, order}: Props) => (
    <div className = {cn.component}>
        <div className = {cn.page}>
            <br/>
            <div className = {cn.heading}>
                <div className = {cn.title}>
                    Заявка Государственной корпорации по атомной энергии «Росатом» на подготовку кадров
                    <br/>
                    с высшим и средним профессиональным образованием по программе целевого обучения
                    <br/>
                    Приложение № {order}
                    <br/>
                </div>
                <div className = {cn.meta}>
                    <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                </div>
                <div className = {cn.meta}>
                    <div className = {cn.label}>Дата заполнения:</div>
                    <div className = {cn.value}>
                        {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                    </div>
                </div>
{/*
                <div className = {cn.meta}>
                    <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                </div>
*/}
            </div>
            <br/>
            <br/>
            <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                <colgroup>
                    {Array.apply(null, Array(opkColumns.length + 8)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                </colgroup>
                <thead className = {cn.head}>
                    <tr className = {cn.headRow}>
                        <td className = {cn.headCell} rowSpan = {3}>Образовательная организация</td>
                        <td className = {cn.headCell} rowSpan = {3}>УО</td>
                        <td className = {cn.headCell} rowSpan = {3}>Форма обучения</td>
                        <td className = {cn.headCell} rowSpan = {2} colSpan = {2}>Направление подготовки / Специальность (НП/С)</td>
                        <td className = {cn.headCell} rowSpan = {3}>Является ли ОПК</td>
                        <td className = {cn.headCell} rowSpan = {2} colSpan = {opkColumns.length + 1}>Заявка</td>
                        <td className = {cn.headCell} rowSpan = {3}>Предприятие</td>
                    </tr>
                    <tr className = {cn.headRow}/>
                    <tr className = {cn.headRow}>
                        <td className = {cn.headCell}>Код</td>
                        <td className = {cn.headCell}>НП/С</td>
                        {opkColumns.map(year => <td className = {cn.headCell} key = {year}>{year - 2000}</td>)}
                        <td className = {cn.headCell}>{`${opkColumns[0] - 2000}-${opkColumns[opkColumns.length - 1] - 2000}`}</td>
                    </tr>
                </thead>
                <tbody>
                    {demand.map((demand: Demand) => {
                        if (!demand.targetRequestTotal(opkColumns)) {
                            return null
                        }

                        const isOpk = companyIsOpk(divisions, demand.companyId)
//                            && universityBranches.get(demand.universityBranchId).specialitiesOpk.has(demand.specialityId)
                        const speciality = getSpeciality(specialities, demand.specialityId)

                        const row = (
                            <Row {...{
                                shift: 0,
                                key: demand.id,
                                demandByYear: demand.targetRequestByYear,
                                company: getCompany(divisions, demand.companyId),
                                speciality,
                                universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                courseOfStudy: demand.courseOfStudy,
                                isOpk,
                            }}/>
                        )

                        if (speciality.master && speciality.bachelorSpecialityId && demand.addBachelorTarget && demand.targetRequestTotal(opkColumns, 4)) {
                            return [
                                row,
                                <Row {...{
                                    shift: 4,
                                    key: demand.id * 10,
                                    demandByYear: demand.targetRequestByYear,
                                    company: getCompany(divisions, demand.companyId),
                                    speciality: getSpeciality(specialities, speciality.bachelorSpecialityId),
                                    universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                    courseOfStudy: demand.courseOfStudy,
                                    isOpk,
                                }}/>,
                            ]
                        } else {
                            return row
                        }

                    }).toList()}
                    <tr className = {cn.totalRow}>
                        <td className = {cn.cell}>Всего:</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {opkColumns.map(year => <td {...{key: year}} className = {cn.cell}>{total[year] || ""}</td>)}
                        <td className = {cn.cell}>{opkColumns.reduce((r, year) => r + total[year], 0) || ""}</td>
                        <td className = {cn.cell}/>
                    </tr>
                    <tr className = {cn.totalRow}>
                        <td className = {cn.cell}>В т.ч. ОПК:</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {opkColumns.map(year => <td {...{key: year}} className = {cn.cell}>{totalOpk[year] || ""}</td>)}
                        <td className = {cn.cell}>{opkColumns.reduce((r, year) => r + totalOpk[year], 0) || ""}</td>
                        <td className = {cn.cell}/>
                    </tr>
                    <tr className = {cn.totalRow}>
                        <td className = {cn.cell}>В т.ч. вне рамок ОПК:</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {opkColumns.map(year => <td {...{key: year}} className = {cn.cell}>{(totalNotOpk[year]) || ""}</td>)}
                        <td className = {cn.cell}>{opkColumns.reduce((r, year) => r + totalNotOpk[year], 0) || ""}</td>
                        <td className = {cn.cell}/>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className = {cn.page}>
            {(
                <div className = {cn.footRow}>
                    <div className = {cn.position}>{user.chief.position}</div>
                    <div className = {cn.name}>{user.chief.fullName}</div>
                    <div className = {cn.sign}>(Подпись)</div>
                </div>
            )}

            <div className = {cn.footRow}>
                <div className = {cn.position}>{user.executor.position}</div>
                <div className = {cn.name}>{user.executor.fullName}</div>
                <div className = {cn.sign}>(Подпись)</div>
            </div>
        </div>
    </div>
)
/*

const css = cssInJS({
    component: {
        pageBreakInside: "auto",
        pageBreakAfter: "always",
        fontSize: 9,
    },
    page: {
        breakInside: "avoid",
        breakAfter: "auto",
        pageBreakInside: "avoid",
        pageBreakAfter: "auto",
        WebkitColumnBreakInside: "avoid",
        WebkitColumnBreakAfter: "auto",
    },
    table: {
        tableLayout: "fixed",
        fontSize: 9,
        width: "100%",
        borderCollapse: "collapse",
        lineHeight: "12px",
    },
    head: {
        display: "table-row-group",
    },
    heading: {
        fontSize: 12,
    },
    title: {
        fontWeight: "bold",
        textAlign: "center",
    },
    meta: {
        fontSize: 11,
        display: "flex",
        flexWrap: "wrap",
        lineHeight: "14px",
    },
    label: {
        fontWeight: "bold",
        marginLeft: (202 / 792 * 100) + "%",
        flexBasis: ((24 + 100) / 792 * 100) + "%",
        flexGrow: 0,
        flexShrink: 0,
        paddingLeft: 2,
        paddingRight: 2,
    },
    value: {
        paddingLeft: 2,
        paddingRight: 2,
        flexBasis: ((46 + 104) / 792 * 100) + "%",
        flexGrow: 0,
        flexShrink: 0,
        textAlign: "center",
    },
    column: {
        width: (18 / 792 * 100) + "%",

        ":nth-of-type(1)": {
            width: (202 / 792 * 100) + "%",
        },

        ":nth-of-type(2)": {
            width: (24 / 792 * 100) + "%",
        },

        ":nth-of-type(3)": {
            width: (100 / 792 * 100) + "%",
        },

        ":nth-of-type(4)": {
            width: (46 / 792 * 100) + "%",
        },

        ":nth-of-type(5)": {
            width: (104 / 792 * 100) + "%",
        },

        ":nth-of-type(6)": {
            width: (55 / 792 * 100) + "%",
        },

        ":nth-of-type(13)": {
            width: (35 / 792 * 100) + "%",
        },

        ":last-of-type": {
            width: (154 / 792 * 100) + "%",
        },
    },
    headRow: {
        fontWeight: "bold",
        lineHeight: "auto",
        textAlign: "center",
        verticalAlign: "top",
        height: 16,

        ":nth-of-type(1)": {
            height: 14,
            verticalAlign: "middle",
        },

        ":nth-of-type(3) > td:nth-of-type(7)": {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    headCell: {
        border: `1px solid black`,
        paddingLeft: 2,
        paddingRight: 2,
    },
    row: {
        textAlign: "right",
        height: 16,
        verticalAlign: "top",
        breakInside: "avoid",
        breakAfter: "auto",
        pageBreakInside: "avoid",
        pageBreakAfter: "auto",
        WebkitColumnBreakInside: "avoid",
        WebkitColumnBreakAfter: "auto",

        ":last-of-type > td": {
            border: `1px solid black`,
            textAlign: "right",
        },
        ":last-of-type > td:nth-of-type(1)": {
            textAlign: "left",
            border: `1px solid transparent`,
            borderTop: `1px dashed black`,
            borderRight: `1px solid black`,
            fontWeight: "bold",
            fontSize: 12,
        },
    },
    totalRow: {
        textAlign: "right",
        height: 16,
        verticalAlign: "top",
        breakInside: "avoid",
        breakAfter: "auto",
        pageBreakInside: "avoid",
        pageBreakAfter: "auto",
        WebkitColumnBreakInside: "avoid",
        WebkitColumnBreakAfter: "auto",

        ":nth-of-type(n) > td": {
            border: `1px solid black`,
            textAlign: "right",
        },
        ":nth-of-type(n) > td:nth-of-type(1)": {
            textAlign: "left",
            border: `1px solid transparent`,
            borderTop: `1px dashed black`,
            borderRight: `1px solid black`,
            fontWeight: "bold",
            fontSize: 12,
        },
    },
    cell: {
        border: `1px dashed black`,
        paddingLeft: 2,
        paddingRight: 2,

        ":nth-of-type(1)": {
            textAlign: "left",
        },

        ":nth-of-type(2)": {
            textAlign: "left",
        },

        ":nth-of-type(3)": {
            textAlign: "center",
        },

        ":nth-of-type(4)": {
            textAlign: "left",
        },

        ":nth-of-type(5)": {
            textAlign: "left",
        },

        ":nth-of-type(6)": {
            textAlign: "left",
        },

        ":nth-of-type(15)": {
            textAlign: "left",
        },
    },

    footRow: {
        marginTop: 16,
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
    },
    position: {
        paddingLeft: 2,
        paddingRight: 2,
        flexBasis: (202 / 792 * 100) + "%",
        width: (202 / 792 * 100) + "%",
        minWidth: (202 / 792 * 100) + "%",
        maxWidth: (202 / 792 * 100) + "%",
        flexGrow: 0,
        flexShrink: 0,
        minHeight: 16 * 3,
        marginRight: ((24 + 100 + 46) / 792 * 100) + "%",
    },
    name: {
        paddingLeft: 2,
        paddingRight: 2,
        flexBasis: ((104 + 18 * 4 + 31) / 792 * 100) + "%",
        minWidth: ((104 + 18 * 4 + 31) / 792 * 100) + "%",
        maxWidth: ((104 + 18 * 4 + 31) / 792 * 100) + "%",
        width: ((104 + 18 * 4 + 31) / 792 * 100) + "%",
        flexGrow: 0,
        flexShrink: 0,
        minHeight: 16 * 3,
        borderBottom: "1px solid black",
    },
    sign: {
        paddingLeft: 2,
        paddingRight: 2,
        flexBasis: (104 / 792 * 100) + "%",
        minWidth: (104 / 792 * 100) + "%",
        maxWidth: (104 / 792 * 100) + "%",
        width: (104 / 792 * 100) + "%",
        marginLeft: ((202 + 24 + 100 + 46) / 792 * 100) + "%",
        flexGrow: 0,
        flexShrink: 0,
        minHeight: 16 * 3,
        textAlign: "center",
        fontStyle: "italic",
    },
})*/
